import ReactPaginate from 'react-paginate'
import './style.css'
import useWindowSize from '../../../../utils/hooks/useWindowSize'
import { useEffect, useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'

const CustomPagination = ({
    styleProps,
    handleRowsPerPage,
    handlePageClick,
    pageCount,
    totalData,
    activePage,
    rowPerPages,
     paginationVariant,
}) => {
    

    const size = useWindowSize()
     const isDashboard = paginationVariant === 'dashboard'

    const marginPagesDisplayed = isDashboard
        ? 1
        : size?.width <= 640
        ? 1
        : size?.width <= 991
        ? 2
        : 3

    const pageRangeDisplayed = isDashboard ? 1 : 2

    return (
        <>
            <div
                className={`mt-2 paginationBorder d-flex flex-column flex-md-column gap-2 ${
                    styleProps
                        ? `flex-lg-column mt-2`
                        : `flex-lg-column flex-xl-row`
                } align-items-center justify-content-between`}
            >
                <section
                    className={`rowPerPage flex-column ${
                        styleProps
                            ? `flex-lg-column mt-2 justify-content-center`
                            : `flex-lg-row`
                    } align-items-center`}
                >
                   <ReactPaginate
                        breakLabel="..."
                        nextLabel={<span title="Next Page" className='paginationTooltip'>&gt;</span>}
                        onPageChange={handlePageClick}
                        marginPagesDisplayed={marginPagesDisplayed}
                pageRangeDisplayed={pageRangeDisplayed}
                        pageCount={pageCount}
                        previousLabel={<span title="Previous Page" className='paginationTooltip'>&lt;</span>}
                        renderOnZeroPageCount={null}
                        breakClassName={'page-item'}
                        forcePage={activePage}
                        breakLinkClassName={'page-link'}
                        containerClassName={'pagination'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                        activeClassName={'active'}
                    />
                </section>
                <div className="d-flex align-items-center gap-3">
                    <div className={`records`}>
                        <select
                            name="rowsPerPage"
                            id="rowsPerPage"
                            className={`rowsperpageSelect ${
                                styleProps && `mt-lg-2`
                            }`}
                            defaultValue={rowPerPages}
                            onChange={handleRowsPerPage}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                            <option value={5000}>5000</option>
                        </select>
                        <IoIosArrowDown className="downArrow" />
                    </div>
                    <p className={`${styleProps && `mt-2`} paginationEntries`}>
                        Showing {rowPerPages * activePage + 1} to{' '}
                        {rowPerPages * (activePage + 1) < totalData
                            ? rowPerPages * (activePage + 1)
                            : totalData}{' '}
                        of {totalData} enteries
                    </p>
                </div>
            </div>
        </>
    )
}

export default CustomPagination
